import React, { useEffect, useState } from "react";
import ConsentListComponent from "./consentListComponent";
import { BusinessConsent } from "../../../services";
import { useDispatch, useSelector } from "react-redux";
import Utils from "../../../utility";
import { hideLoader, removeUser, showLoader } from "../../../slices/userSlice";
import { keyConstants } from "../../../constants";

const ConsentList = () => {
  const { IS_REFRESH_TOKEN_LOADING } = keyConstants;
  const [state, setState] = useState({
    userConsentData: [],
    userConsentTypes: [],
    page: 1, // initial page
    itemsPerPage: 10, // page limit
    totalItems: 0
  });
  const user = useSelector((state) => state.user);
  const dispatch = useDispatch();

  const changeState = (name, value) => {
    setState((prevList) => ({
      ...prevList,
      [name]: value
    }));
  };

  const getConsentListById = async () => {
    const tokenStatus = await Utils.checkTokenExpireOrNot(getConsentListById);
    if (tokenStatus) {
      if (tokenStatus === IS_REFRESH_TOKEN_LOADING) {
        dispatch(showLoader());
        return;
      }
      dispatch(removeUser({}));
      return;
    }
    try {
      dispatch(showLoader());
      const [, userConsentTypeList] = await Utils.parseResponse(
        new BusinessConsent().getConsentList(user._id)
      );
      if (
        userConsentTypeList &&
        userConsentTypeList?.consents &&
        userConsentTypeList?.consents?.length > 0
      ) {
        const updatedConsentList = [
          { name: "None", _id: "" },
          ...userConsentTypeList.consents
        ];
        changeState("userConsentTypes", updatedConsentList);
      } else {
        changeState("userConsentTypes", [{ name: "None", _id: "" }]);
      }
    } finally {
      dispatch(hideLoader());
    }
  };

  const handleChangePage = (event, newPage) => {
    changeState("page", newPage);
  };

  useEffect(() => {
    getConsentListById();
  }, []);

  return (
    <ConsentListComponent
      states={state}
      setState={changeState}
      handleChangePage={handleChangePage}
    />
  );
};

export default ConsentList;
